import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'AffiliateManagerService'
const host = servicesConfig.AffiliateManager
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const AffiliateManagerService = {
  initialData: (id: string) =>
    request().get(`/${id}/init`).then(responseBody),
    
  getLocationCustomisation: (locationId: string) =>
    request().get(`/${locationId}/location-customization`).then(responseBody)
}

export default AffiliateManagerService
